import { useConfig } from "../containers/ConfigContext";
import { UserTypeEnum, checkIfHasPermission } from "../models/authorize.model";

export default function CheckPermission(props: {
  roles?: UserTypeEnum[];
  children: JSX.Element;
}) {
  const { roles } = props;
  const { loggedUser } = useConfig();
  return checkIfHasPermission(loggedUser, roles) ? props.children : null;
}
